// Author TianHaiQing
// Date 2025-04-03 09:21:59

class InspectionScheduleTimeoutRecord {
constructor({
        id = null,
        inspectionScheduleId = '',
        inspectionCategoryId = '',
        scheduleName = '',
        executor = '',
        abnormalPlanner = '',
        periodicUnit = '',
        periodicValue = '',
        nextExecutionDate = '',
        suspensionState = '',
        lastExecutionDate = '',
        executeStatusCode = '',
        executeStatusName = '',
        executeStatus = '',
        executeTimeoutCount = '',
        executeTimeoutRecordDate = '',
        description = ''}
= {}) {
    this.id = id;
    this.inspectionScheduleId = inspectionScheduleId;
    this.inspectionCategoryId = inspectionCategoryId;
    this.scheduleName = scheduleName;
    this.executor = executor;
    this.abnormalPlanner = abnormalPlanner;
    this.periodicUnit = periodicUnit;
    this.periodicValue = periodicValue;
    this.nextExecutionDate = nextExecutionDate;
    this.suspensionState = suspensionState;
    this.lastExecutionDate = lastExecutionDate;
    this.executeStatusCode = executeStatusCode;
    this.executeStatusName = executeStatusName;
    this.executeStatus = executeStatus;
    this.executeTimeoutCount = executeTimeoutCount;
    this.executeTimeoutRecordDate = executeTimeoutRecordDate;
    this.description = description;
}
}

function newEntity() {
return new InspectionScheduleTimeoutRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inspectionScheduleId',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.inspectionScheduleId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inspectionCategoryId',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.inspectionCategoryId',
        sortable: true,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionCategory'
                        }
        },
        {
        key: 'scheduleName',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.scheduleName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executor',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.executor',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executorRealName',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.executorRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'abnormalPlanner',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.abnormalPlanner',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'abnormalPlannerRealName',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.abnormalPlannerRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'periodicUnit',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.periodicUnit',
        sortable: true,
        form: {
        type: 'scheduledPeriodicUnit',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'periodicValue',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.periodicValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'nextExecutionDate',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.nextExecutionDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'suspensionState',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.suspensionState',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lastExecutionDate',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.lastExecutionDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeStatusCode',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.executeStatusCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeStatusName',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.executeStatusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeStatus',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.executeStatus',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeTimeoutCount',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.executeTimeoutCount',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'executeTimeoutRecordDate',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.executeTimeoutRecordDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    inspectionScheduleIdFilter : '',
    inspectionCategoryIdFilter : '',
    scheduleNameFilter : '',
    executorFilter : '',
    abnormalPlannerFilter : '',
    periodicUnitFilter : '',
    periodicValueFilter : '',
    nextExecutionDateRteFilter : '',
    nextExecutionDateLteFilter : '',
    suspensionStateFilter : '',
    lastExecutionDateRteFilter : '',
    lastExecutionDateLteFilter : '',
    executeStatusCodeFilter : '',
    executeStatusNameFilter : '',
    executeStatusFilter : '',
    executeTimeoutCountFilter : '',
    executeTimeoutRecordDateEqFilter : '',
    executeTimeoutRecordDateRteFilter : '',
    executeTimeoutRecordDateLteFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'inspectionScheduleIdFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.inspectionScheduleId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionCategoryIdFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.inspectionCategoryId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'scheduleNameFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.scheduleName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executorFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.executor',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'abnormalPlannerFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.abnormalPlanner',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'periodicUnitFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.periodicUnit',
        disabled: false,
        form: {
        type: 'scheduledPeriodicUnit',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'periodicValueFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.periodicValue',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nextExecutionDateRteFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.nextExecutionDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nextExecutionDateLteFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.nextExecutionDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'suspensionStateFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.suspensionState',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastExecutionDateRteFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.lastExecutionDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastExecutionDateLteFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.lastExecutionDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeStatusCodeFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.executeStatusCode',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeStatusNameFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.executeStatusName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeStatusFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.executeStatus',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeTimeoutRecordDateRteFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.executeTimeoutRecordDateRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeTimeoutRecordDateLteFilter',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.filter.executeTimeoutRecordDateLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'inspectionScheduleId',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.inspectionScheduleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionCategoryId',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.inspectionCategoryId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scheduleName',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.scheduleName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executor',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.executor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'abnormalPlanner',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.abnormalPlanner',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'periodicUnit',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.periodicUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'periodicValue',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.periodicValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nextExecutionDate',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.nextExecutionDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'suspensionState',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.suspensionState',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastExecutionDate',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.lastExecutionDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeStatusCode',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.executeStatusCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeStatusName',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.executeStatusName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeStatus',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.executeStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeTimeoutCount',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.executeTimeoutCount',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'executeTimeoutRecordDate',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.executeTimeoutRecordDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionScheduleTimeoutRecord.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {InspectionScheduleTimeoutRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
